import React from 'react';
import { useAppContext } from '../contexts/AppContext';
import { Shield, Clock, LogOut, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PendingAccessPage: React.FC = () => {
    const { currentUser, logout } = useAppContext();
    const navigate = useNavigate();

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleLogout = async () => {
        await logout();
        navigate('/admin/login');
    };

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
            <div className="bg-card p-8 rounded-xl shadow-2xl max-w-md w-full text-center border border-border">
                <div className="w-16 h-16 bg-orange-100 dark:bg-orange-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Shield className="w-8 h-8 text-orange-600 dark:text-orange-400" />
                </div>

                <h1 className="text-2xl font-bold text-text-primary mb-2">Access Pending</h1>

                <div className="mb-6 space-y-2">
                    <p className="text-text-secondary">
                        Your account has been created but requires administrator approval before you can access the system.
                    </p>
                    <div className="bg-background p-3 rounded-lg border border-border text-sm font-mono text-text-primary">
                        {currentUser?.username || 'User'}
                        {currentUser?.email ? ` (${currentUser.email})` : ''}
                    </div>
                </div>

                <div className="flex items-center justify-center gap-2 text-sm text-text-secondary mb-8">
                    <Clock className="w-4 h-4" />
                    <span>Request submitted. Please wait for review.</span>
                </div>

                <div className="flex flex-col gap-3">
                    <button
                        onClick={handleRefresh}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-primary hover:bg-secondary text-white rounded-lg transition-colors"
                    >
                        <RefreshCw className="w-4 h-4" />
                        Check Status
                    </button>

                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-background hover:bg-gray-200 dark:hover:bg-gray-700 text-text-primary rounded-lg transition-colors border border-border"
                    >
                        <LogOut className="w-4 h-4" />
                        Sign Out
                    </button>
                </div>
            </div>

            <p className="mt-8 text-xs text-text-secondary opacity-50">
                Living Reliability Systems • Access Control
            </p>
        </div>
    );
};

export default PendingAccessPage;
